export default "assets/images/full-logo-e1c60b82.svg";